export const apiGetCountLogin = process.env.REACT_APP_API_COUNTLOGIN;
export const apiGetRoleLists = process.env.REACT_APP_API_GET_ROLELISTS;
export const apiGetMemberRoles = process.env.REACT_APP_API_GET_MEMBERROLES;
